module.exports = __webpack_public_path__ + "img/1-4.48906cf1.png";